import { Fnv } from 'utilities/Fnv';
import { reflectStorage } from 'utils/ReflectStorage';

const VALUE = '1';

export function once(uid, callback) {
    const key = `mcs_once_${Fnv.getInt36Fnv32aHash(uid)}`;

    if (reflectStorage.getItem(key) !== VALUE) {
        reflectStorage.setItem(key, VALUE);
        callback();
    }
}
